import templateUrl from './userBaseWageComponent.html';

export default {
  templateUrl,
  bindings: {
    wage: '<',
    addWage: '&',
    deleteWage: '&',
    placeholderWage: '<',
    readOnly: '<?',
  },
  controllerAs: 'ctrl',
  controller(Utils) {
    'ngInject';

    this.numberWithDecimalPattern = Utils.getNumberValidationPattern();
  },
};
